import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { UsersService } from '../Services/users.service';
import { BeneficiaryService } from '../Services/beneficiary.service';
import { NgModule } from '@angular/core';
import { HttpEventType, HttpClient } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { BeneficiaryAccountProperties } from '../Models/BeneficiaryAccountProperties';
import { Router } from '@angular/router';
import * as $ from 'jquery';
import { formatDate } from '@angular/common';
declare const NaveStartup: any;

@Component({
  selector: 'app-beneficiary-account',
  templateUrl: './beneficiary-account.component.html',
  styleUrls: ['./beneficiary-account.component.css']
})
@NgModule({ imports: [FormsModule] })

export class BeneficiaryAccountComponent {
  constructor(private usersService: UsersService, private http: HttpClient, private router: Router, private beneficiaryService: BeneficiaryService) { };
  beneficiaryCObj = new BeneficiaryAccountProperties();
  isExpanded = false;

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }


  
  ngOnInit() {
    NaveStartup();
    this.LoadEditableData();
    this.checkBeneficaryAccountRight();
  }
  //checkBeneficaryAccountRight() {
  //  this.beneficiaryService.CheckRightsAgaintAgencyAndUserId(localStorage.getItem("AgencyId"), localStorage.getItem("UserId")).subscribe((data) => {
  //    if (data) {

  //      $("#btnSave").removeAttr("disabled");
  //    }
  //    else {
  //      $("#btnSave").attr("disabled", "disabled");
  //    }
  //  });
  //}


  checkBeneficaryAccountRight() {
    this.beneficiaryService.CheckRightsAgaintAgencyAndUserId(localStorage.getItem("AgencyId"), localStorage.getItem("UserId")).subscribe((data) => {
      if (data) {

        $("#btnSave").removeAttr("disabled");
      }
      else {
        $("#btnSave").attr("disabled", "disabled");
      }
    });
  }
  LoadEditableData() {
    try {
      if (localStorage.getItem("accountNo") != "" || localStorage.getItem("accountNo") != null) {
        let accountNo = (localStorage.getItem("accountNo"));
        if (accountNo != "" || accountNo != null) {
          this.beneficiaryService.getBeneficiaryByNo(accountNo).subscribe((data) => {
            this.beneficiaryCObj = data[0] as BeneficiaryAccountProperties;
            localStorage.removeItem("accountNo");
          });
        }
      }
    }
    catch (e) {
      //console.log(e);
    }
  }
  onSubmit() {

    this.beneficiaryCObj.modifyUser = Number(localStorage.getItem("modifyUser"));
    if (this.beneficiaryCObj.accountNo != "" && this.beneficiaryCObj.name != "" && this.beneficiaryCObj.reference != ""  && this.beneficiaryCObj.accountTitle != null && this.beneficiaryCObj.bankName != "" && this.beneficiaryCObj.branch != "" && this.beneficiaryCObj.iban != "") {
      this.beneficiaryService.updateBeneficiary(this.beneficiaryCObj).subscribe((data => {
        if (data === true) {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Account updated Successfully :)"
          $("#response-screen").delay(5000).hide(1000);
        }
        else {
          $("#response-screen").show();
          document.getElementById("response-screen").innerHTML = "Error occured while updating Account :("
          $("#response-screen").delay(5000).hide(1000);
        }
      }));
    }
    else {
      $("#response-screen").show();
      document.getElementById("response-screen").innerHTML = "Please fill in All Required fields"
      $("#response-screen").delay(5000).hide(1000);
    }
  }
  cancel() {
    this.beneficiaryCObj = new BeneficiaryAccountProperties();
  }
  onClickSave() {}
}
